import React from 'react';

import { useTeamsUser } from '@atlassian/teams/user';

import AvatarDefault from './AvatarDefault';
import { DEFAULT_IMAGE_SIZE } from './constants';
import { type AvatarByAccountIdProps } from './types';

const AvatarByAccountId = (props: AvatarByAccountIdProps): React.JSX.Element => {
	const { accountId, imageSize = DEFAULT_IMAGE_SIZE, ...pureAvatarComponentProps } = props;
	const { isLoading, error, data: userFromAGG } = useTeamsUser(accountId);
	const src = (!isLoading && error === undefined && userFromAGG && userFromAGG.avatarUrl) || '';

	return <AvatarDefault {...pureAvatarComponentProps} src={src} imageSize={imageSize} />;
};

export default AvatarByAccountId;
